import React, { useState } from 'react';
import { ModalBase } from './ModalBase';

interface CadastroParceiroForm {
  businessName: string;
  cnpj: string;
  responsible: string;
  phone: string;
  city: string;
}

export function CadastroParceiroModal() {
  const [form, setForm] = useState<CadastroParceiroForm>({
    businessName: '',
    cnpj: '',
    responsible: '',
    phone: '',
    city: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (field: keyof CadastroParceiroForm) => (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleSubmit = () => {
    setSubmitted(true);
  };

  return (
    <ModalBase>
      <h3 className="modal-box__title">Cadastro de parceiro</h3>
      <p className="modal-box__subtitle">Conte sobre seu lava-rápido</p>

      <label className="modal-form__label">
        Nome do lava-rápido <span className="modal-form__label-required">*</span>
      </label>
      <input
        type="text"
        placeholder="Ex: Lava Rápido Estrela"
        value={form.businessName}
        onChange={handleChange('businessName')}
        className="modal-form__input"
      />

      <label className="modal-form__label">
        CNPJ <span className="modal-form__label-required">*</span>
      </label>
      <input
        type="text"
        placeholder="00.000.000/0000-00"
        value={form.cnpj}
        onChange={handleChange('cnpj')}
        className="modal-form__input"
      />

      <label className="modal-form__label">
        Responsável <span className="modal-form__label-required">*</span>
      </label>
      <input
        type="text"
        placeholder="Seu nome"
        value={form.responsible}
        onChange={handleChange('responsible')}
        className="modal-form__input"
      />

      <label className="modal-form__label">
        Telefone <span className="modal-form__label-required">*</span>
      </label>
      <input
        type="text"
        placeholder="(11) 90000-0000"
        value={form.phone}
        onChange={handleChange('phone')}
        className="modal-form__input"
      />

      <label className="modal-form__label">
        Cidade / UF <span className="modal-form__label-required">*</span>
      </label>
      <input
        type="text"
        placeholder="São Paulo / SP"
        value={form.city}
        onChange={handleChange('city')}
        className="modal-form__input"
      />

      <button className="modal-form__submit" onClick={handleSubmit}>
        Enviar cadastro
      </button>

      {submitted && (
        <div className="modal-form__success">
          Cadastro enviado! Nosso time entrará em contato em até 48h.
        </div>
      )}
    </ModalBase>
  );
}
